import { GuideMembershipsList } from '../../entities/membership/components/MembershipsList';

export const GuideHome = () => {
    // No specs for this view yet, so just return the memberships list for now
    return <GuideMembershipsList />;
};
